var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.ready)?_c('div',{staticClass:"flix-text-center"},[_c('h2',{staticClass:"flix-html-h2"},[_vm._v(_vm._s(_vm.$t('message.generatePDF')))]),_c('flixLoader')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }